import FednowTabs from "./FednowTabs";

import CaseTable from "./CaseTable";
import { useParams } from "react-router-dom";

type IdParam = {
  id: string | undefined;
};

export default function FednowPaymentContainer() {
  const { id } = useParams<IdParam>();
  return (
    <FednowTabs tab="cases">
      <div className="padding--y" style={{ display: "block" }}>
        <CaseTable selectedId={id} />
      </div>
    </FednowTabs>
  );
}
